<template>
  <box-model title="农资使用量占比与排行">
    <template v-slot:content>
      <div class="select-part">
        <select-box :sty="false" :list="selList" :item="selItem" @sel="selEvent"></select-box>
      </div>
      <div class="b-content flex-center">
        <div class="pie-sty">
          <div id="amEchart" class="pie-chart"></div>
          <div class="pie-tips">
            <div v-for="(item, idx) in data" :key="idx" class="pie-tips-item flex-y-center">
              <div class="cyc" :style="`background: ${item.color};`"></div>
              <div>{{ item.name }}</div>
              <div class="num" :style="`color: ${item.color}`">{{ item.dosage }}</div>
              <span>{{ item.unit }}</span>
            </div>
          </div>
        </div>
        <div class="bg-line-sty-sc">
          <div class="table">
            <div class="title-row flex-between">
              <div class="c-item c-title-sty">排名</div>
              <div class="c-item c-title-sty">农资名称</div>
              <div class="c-item c-title-sty">使用数量</div>
              <div class="c-item c-title-sty">单位</div>
            </div>
            <div v-if="!list.length" class="c-row" style="color: #ffffff;text-align: center;padding-top: 100px;">暂无数据</div>
            <div v-for="(item, index) in list" :key="index" class="c-row flex-between" :class="index %2 ? 'c1' : 'c2'">
              <div class="c-item c-item-sty">{{ index + 1 }}</div>
              <div class="c-item c-item-sty">{{ item.agriculturalName || '--' }}</div>
              <div class="c-item c-item-sty">{{ item.dosage || '--' }}</div>
              <div class="c-item c-item-sty">{{ item.unit || '--' }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import { statisticsFarmLogs, statisticsFarmLogsTypeList } from "@/api/index";
  import echarts from 'echarts';
  export default {
    data() {
      return {
        selList: [],
        selItem: {},

        color: {
          0: '#38EAFF',
          1: '#FFFFFF',
          2: '#FFCC00'
        },

        data: [],
        sumValue: 0,

        list: []
      }
    },
    components: {
      "box-model": () => import("../../components/common/Model.vue"),
      "select-box": () => import("../../components/common/SelectBox.vue")
    },
    mounted() {
      this.getYearFn();
    },
    methods: {
      // 年份获取
      getYearFn(){
        const curYear = new Date().getFullYear();
        this.selList = [
          {name: `${curYear}年`, value: curYear},
          {name: `${curYear - 1}年`, value: curYear-1},
          {name: `${curYear - 2}年`, value: curYear-2}
        ];
        this.selItem = this.selList[0];
        this.statisticsFarmLogsFn();
        this.statisticsFarmLogsTypeListFn();
      },
      selEvent(item) {
        this.selItem = item;
        this.statisticsFarmLogsFn();
        this.statisticsFarmLogsTypeListFn();
      },
      statisticsFarmLogsTypeListFn(){
        statisticsFarmLogsTypeList({
          year: this.selItem.value
        }).then((res) => {
          if(!res.data){
            this.list = [];
            return;
          };
          this.list = res.data;
        });
      },

      init() {
        const myChart = echarts.init(document.getElementById("amEchart"));
        let arrName = this.getArrayValue(this.data, "name");
        let arrValue = this.getArrayValue(this.data, "value");
        this.sumValue = eval(arrValue.join('+'));
        let objData = this.array2obj(this.data, "name");
        let optionData = this.getData(this.data);
        let colors = this.getColorArr(this.data);
        let option = {
          tooltip: {
            show: true,
            trigger: "item",
            backgroundColor: 'rgba(255,255,255,.9)',
            formatter: function(item){
              let result = `
                <div style="padding: 12px;z-index:1001">
                  <div style="color: #3E3E3E;font-size: 16px;">${item.name}</div>
                  <div style="width: 100%;height: 1px;background: #E8E8EA;margin:8px 0; "></div>
                  <div style="display: flex;align-items: center;">
                    <div style="width: 8px;height: 8px;background: ${item.color};border-radius: 50%;"></div>
                    <div style="color: #000E2B;font-size: 16px;margin-left: 4px;line-height: 16px;">使用量：${item.value}kg</div>  
                  </div>
                </div>
              `;
              return result;
            },
          },
          color: colors,
          grid: {
            top: '6%',
            bottom: '64%',
            left: "50%",
            containLabel: false
          },
          yAxis: [{
            type: 'category',
            inverse: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              inside: true,
              textStyle: {
                color: "#fff",
                fontSize: 10,
              },
              show: true
            },
            data: optionData.yAxis
          }],
          xAxis: [{
            show: false
          }],
          series: optionData.series
        };
        myChart.setOption(option);
      },
      getColorArr(array) {
        let result = [];
        array.forEach((item) => {
          result.push(item.color)
        });
        return result;
      },
      getArrayValue(array, key) {
        var key = key || "value";
        var res = [];
        if (array) {
          array.forEach(function(t) {
            res.push(t[key])
          })
        }
        return res
      },
      array2obj(array, key) {
        var resObj = {};
        for (var i = 0; i < array.length; i++) {
          resObj[array[i][key]] = array[i]
        }
        return resObj
      },
      getData() {
        var res = {
          series: [],
          yAxis: []
        };
        for (let i = 0; i < this.data.length; i++) {
          res.series.push({
            name: '数据',
            type: 'pie',
            clockWise: false,
            hoverAnimation: false,
            radius: [85 - i * 15 + '%', 75 - i * 15 + '%'],
            center: ["50%", "50%"],
            label: {
              show: false
            },
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false
              },
              borderWidth: 5,
            },
            data: [{
              value: this.data[i].value,
              name: this.data[i].name
            }, {
              value: this.sumValue ? this.sumValue - this.data[i].value : 100,
              name: '',
              itemStyle: {
                color: "rgba(0,0,0,0)",
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }]
		      });
          res.series.push({
            name: '',
            type: 'pie',
            silent: true,
            z: 1,
            clockWise: false,
            hoverAnimation: false,
            radius: [85 - i * 15 + '%', 75 - i * 15 + '%'],
            center: ["50%", "50%"],
            label: {
              show: false
            },
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false
              },
              borderWidth: 5,
            },
            data: [{
              value: 7.5,
              itemStyle: {
                color: "rgba(255,255,255,.1)",
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }, {
              value: 2.5,
              name: '',
              itemStyle: {
                color: "rgba(0,0,0,0)",
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }]
          });
          if(this.sumValue){
            res.yAxis.push((this.data[i].value / this.sumValue * 100).toFixed(2) + "%");
          } else {
            res.yAxis.push('0%');
          };
        };
        return res;
      },
      statisticsFarmLogsFn(){
        statisticsFarmLogs({
          year: this.selItem.value
        }).then((res) => {
          if(!res.data || !res.data?.length){
            this.show = false;
            return;
          };
          const result = res.data;
          const color = this.color;
          const list = [];
          result.forEach((item, index) => {
            if(item.agriculturalName != '其他'){
              item['name'] = item.agriculturalName;
              item['value'] = item.dosage ? +item.dosage : 0;
              item['color'] = color[index];
              list.push(item);
            }
          });
          this.show = true;
          this.data = list;
          this.$nextTick(()=> {
            this.init();
          });
        })
      },
    }
  }
</script>
<style scoped lang="less">
  .flex-center {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .flex-y-center {
    display: flex;
    align-items: center;
  }
  .select-part {
    position: absolute;
    top: -10px;
    right: 10px;
    width: 100px;
    font-size: 18px;
    font-weight: 400;
  }
  .b-content {
    width: 100%;
    height: 438px;
    .pie-sty {
      height: 100%;
      width: 260px;
      
      .pie-chart {
        width: 100%;
        height: 220px;
      }
      .pie-tips {
        width: 100%;
        margin-top: 30px;
        .pie-tips-item {
          width: 100%;
          height: 20px;
          font-size: 22px;
          font-weight: 400;
          padding: 0 44px;
          color: #FFFFFF;
          margin-bottom: 20px;
          .cyc {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            opacity: 1;
            margin-right: 8px;
          }
          .num {
            font-size: 22px;
            font-weight: 400;
            margin-left: auto;
          }
        }
        .pie-tips-item:last-child {
          margin-bottom: 0;
        }
      }
    }
    .bg-line-sty-sc {
      height: 100%;
      width: calc(100% - 260px);
      .table {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        margin-top: 20px;
        .title-row {
          width: 100%;
          height: 32px;
          background: rgba(9, 148, 255, .19);
        }
        .c-row {
          width: 100%;
          height: 40px;
        }
        .c1 {
          background: rgba(9, 148, 255, 0.14);
        }
        .c2 {
          background: rgb(2, 12, 31);
        }
        .c-item {
          width: 25%;
          height: 100%;
          font-size: 18px;
          font-weight: 400;
          color: rgba(255,255,255,0.8);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0 12px;
        }
        .c-item-sty {
          line-height: 40px;
        }
        .c-title-sty {
          color: #FFFFFF;
          font-size: 18px;
          line-height: 32px;
        }
      }
    }
}
</style>